// @ts-nocheck
import Button from 'atoms/button/button';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import React from 'react';
import Modal from 'atoms/modal/modal';
import Sheet from 'atoms/sheet/sheet';
import SheetBody from 'atoms/sheet/sheetBody/sheetBody';
import { useDispatch, useSelector } from 'react-redux';
import { exportGridData } from 'models/dynamicGrid/sagaActions';
import TextInput from 'atoms/TextInput/textInput';
import Label from 'atoms/label/label';
import { Spin, Tooltip } from 'antd';
import { isLoadingEnabled } from 'models/loaders/selectors';
import { useEffect } from 'react';
import { Events } from 'molecules/ReactGrid/agGrid/utils/events';
import { GRID_EVENTS } from 'molecules/ReactGrid/agGrid/constants';
import { getTableColumns } from 'models/tableColumns/selector';
import { LoadingOutlined } from '@ant-design/icons';
import { Button as AntButton } from 'antd';

const ExportGrid = (props: Props) => {
	const { tableId, fieldGroups, extraFilters } = props;
	const dispatch = useDispatch();
	const [isModalOpen, toggleModal] = React.useState(false);
	const [exportName, updateExportName] = React.useState('');
	const isLoading = useSelector((state) => isLoadingEnabled(state, 'download/' + tableId));

	const getTableColumn = useSelector((state) => getTableColumns(state, tableId));

	// Map over the table columns to get the enabled column names
	const enabledColumns = getTableColumn
		?.filter(
			(column) =>
				column.IsColumnEnabled === true &&
				typeof column.AppColumnName === 'string' &&
				column.AppColumnName !== '0' &&
				column.AppColumnName !== 'additionalInfo' &&
				column.AppColumnName !== 'HealthCheck'
		)
		.map((column) =>
			column.AppColumnAliasName
				? `${column.AppColumnName} as [${column.AppColumnAliasName}]`
				: column.AppColumnName
		); // Extract only the column names

	// Join the enabled column names into a comma-separated string
	const selectColumnList = enabledColumns?.join(',');

	const exportGrid = () => {
		dispatch(
			exportGridData({
				tableId,
				exportName,
				fieldGroups,
				extraFilters,
				selectColumnList, // Pass the selectColumnList here
			})
		);
		toggleModal(false);
	};

	useEffect(() => {
		Events.subscribe(GRID_EVENTS.EXPORT, (data) => {
			toggleModal(true);
		});
	}, []);

	return (
		<>
			<Tooltip title={isLoading ? 'Download In Progress' : 'Export Data'}>
				<AntButton
					className="menu-action--button"
					onClick={() => toggleModal(true)}
					type="primary"
					loading={isLoading && { icon: <LoadingOutlined spin /> }}
					icon={<i className="icon-import" isActive type="secondary" />}
				/>
			</Tooltip>
			{isModalOpen && (
				<Modal hideModal={() => toggleModal(false)} height={300}>
					<Sheet isInset>
						<SheetBody>
							<Stack isVertical gutter="small" className="common-modal-content">
								<StackItem isStretch className="common-modal-header">
									Create a Named Export
								</StackItem>

								<StackItem isGrow className="common-modal-body">
									<Stack isVertical gutter="medium">
										<StackItem isStretch>
											<Label>Please enter a name for this file download</Label>
										</StackItem>
										<StackItem>
											<TextInput
												name="export"
												onChange={(e) => updateExportName(e.target.value)}
											/>
										</StackItem>
									</Stack>
								</StackItem>
							</Stack>
						</SheetBody>
						<StackItem isStretch className="p-0">
							<Stack className="common-modal-actions">
								<StackItem>
									<Button isText ismodalCancelButton handleClick={() => toggleModal(false)}>
										{' '}
										Cancel{' '}
									</Button>
								</StackItem>
								<StackItem isStretch align="right">
									<Button isPrimary disabled={!exportName} handleClick={exportGrid}>
										{' '}
										Export Data{' '}
									</Button>
								</StackItem>
							</Stack>
						</StackItem>
					</Sheet>
				</Modal>
			)}
		</>
	);
};

export default ExportGrid;
